const handleError = (errorCode:any) => {
    if( errorCode === 401) {
        //do nothing
    }
    return null;
}

export default handleError;
